import {NgModule} from '@angular/core';

import {ActeDossierTableComponent} from './acte-dossier-table.component';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
    ],
  exports: [ActeDossierTableComponent],
  declarations: [ActeDossierTableComponent],
  providers: [],
})
export class ActeDossierTableModule {
}
